import { render, staticRenderFns } from "./BigViewIns.vue?vue&type=template&id=c9b5c4d8&scoped=true&"
import script from "./BigViewIns.vue?vue&type=script&lang=js&"
export * from "./BigViewIns.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9b5c4d8",
  null
  
)

export default component.exports